import React from 'react';
import { NavLink } from 'react-router-dom';
import { Outlet } from 'react-router';
import './assignments.scss';
import AssignmentFloatingMenu from '../../components/AssignmentFloatingMenu';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const assignmentNav = [
  {
    id: 1,
    name: 'Assignments',
    navigation: '',
    comingSoon: false
  },
  {
    id: 2,
    name: 'Activities',
    navigation: 'activities',
    comingSoon: true
  },
  {
    id: 3,
    name: 'Admin Assessments',
    navigation: 'admin_assessments',
    comingSoon: true
  }
];

const Index = () => {
  const LayOut = () => {
    return (
      <>
        <div className="white-card assignments-card">
          <h2 className="primary-title">Assignments and Activities</h2>
          <div className="primary-tab">
            <div className="btn-group">
              {assignmentNav.map((item, index) => {
                return (
                  item.comingSoon?(
                    <OverlayTrigger
                      key={'assignmentTab'+ index}
                      placement="top"
                      overlay={<Tooltip className="custom-tooltip">{'Coming Soon!'}</Tooltip>}>
                      <NavLink
                        key={index}
                        to={''}
                        className={({ isActive }) => (isActive ? 'btn' : '')}>
                        {item.name}
                      </NavLink>
                    </OverlayTrigger>
                  ):(
                    <NavLink
                      key={index}
                      end
                      to={`${item.navigation}`}
                      className={({ isActive }) => (isActive ? 'btn active rounded' : 'btn') + (item.comingSoon? ' disabled' : '')}>
                      {item.name}
                    </NavLink>
                  )
                );
              })}
            </div>
          </div>
          <Outlet />
        </div>
      </>
    );
  };

  const FloatingMenu = () => {
    return (
      <>
        <div className="floating-menu-space"></div>
        <div className="floating-menu">
          <AssignmentFloatingMenu />
        </div>
      </>
    );
  };

  return (
    <React.Fragment>
      <LayOut />
      <FloatingMenu />
    </React.Fragment>
  );
};

export default Index;
